













import {Component, Prop, Vue} from 'nuxt-property-decorator'
import RadioSelection from './RadioSelection.vue'

@Component
export default class Tab extends Vue {
  public isSelected: boolean = false;

  clicked () {
    const parent = this.$parent as RadioSelection
    parent.select(this.value)
  }

  @Prop({required: true})
  public readonly value!: any
}

